// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eVV1H","left":"styles_left__2o-P3","desktopActions":"styles_desktopActions__3DuBd","title":"styles_title__1nrQV"};